import React from 'react';
import { Badge } from 'reactstrap';
import { formatProfileType } from '../../lib/helpers/profiles';

function ProfileFieldType({ value }) {
  return <Badge className={`siwego-${value}`}>{formatProfileType(value)}</Badge>;
}

export default ProfileFieldType;
